import { connect } from 'react-redux';
import ScreenInfo from '../components/ScreenInfo';
import { getNoOfScreens, getScreenOrder } from '../selectors';
import { getCurrentScreen } from '../selectors/screen';
function mapStateToProps(state) {
    if (state.project.isLoading) {
        return {
            isVisible: false,
        };
    }
    var currentScreen = getCurrentScreen(state);
    return {
        screenName: currentScreen.name,
        screenNumber: getScreenOrder(state, currentScreen.id),
        screenCount: getNoOfScreens(state),
        isVisible: state.screen.showScreenInfo,
    };
}
export default connect(mapStateToProps, null, null, { pure: true })(ScreenInfo);
